import io from 'socket.io-client';
import eventNames from './eventNames';
import renewUrgentNewsHandler from './eventHandlers/renewUrgentNews';
import renewNotificationListHandler from "./eventHandlers/renewNotificationList";
import {getBaseUrl} from 'Core/helpers/urlHelper';
import {getSessionId} from 'Core/helpers/metaHelper';

const baseUrl = getBaseUrl();
const sessionId = getSessionId();

const startSocketIO = () => {
    if (/bot/.test(window.navigator.userAgent)) {
        return;
    }

    let url = getBaseUrl();

    if (url !== 'http://gol.int' && !/\/rc\./.test(url)) {
        url = 'https://share.gol.ru';
    }

    const socket = io(`${url}:3000`, {
        query: {
            sessionId: sessionId
        }
    });

    socket.on(eventNames.renewUrgentNews, renewUrgentNewsHandler);
    socket.on(eventNames.renewNotificationList, renewNotificationListHandler);
};

startSocketIO();
